module.exports = __webpack_public_path__ + "media/components/star-rating/static/yellow/11-7b701e19112e7449cbfa442c05aac5d8.svg";